import { Hero } from '../components/Hero/Hero'
// import { ContactForm } from '../components/ContactForm/ContactForm'
import './home.css'

export function HomePage() {
  return (
    <>
      <Hero />

      {/* ── About / Company Description ── */}
      <section id="about" className="section home-about">
        <div className="container home-about__grid">

          <div className="home-about__left">
            <span className="label">Who We Are</span>
            <h2>A small team.<br /><span className="gradient-text">Serious craft.</span></h2>
          </div>

          <div className="home-about__right">
            <p className="home-about__body">
              Adaptive Web Solutions is a boutique web development studio based in Clearwater, Florida.
              We partner with startups and growing businesses that demand more than a template — they demand
              a digital presence that works as hard as they do.
            </p>
            <p className="home-about__body">
              We specialize in full-stack React applications, performant UI/UX, and cloud-native
              architecture. Every line of code we write is built to adapt as your business evolves.
              No bloat, no shortcuts — just clean, modern, maintainable software delivered on time.
            </p>
            <p className="home-about__body">
              Remote-first and client-focused, we treat every project as a long-term partnership.
              When you work with us, you get senior engineers on your code.
            </p>
          </div>
        </div>
      </section>

      {/* ── Motto ── */}
      <section className="home-motto" aria-label="Company motto">
        <div className="container">
          <div className="home-motto__inner">
            <div className="home-motto__glow" aria-hidden="true" />
            <div className="home-motto__words">
              <span className="home-motto__word">
                <em>Adapt</em>
                <span className="home-motto__sub">to every challenge</span>
              </span>
              <span className="home-motto__divider" aria-hidden="true">—</span>
              <span className="home-motto__word">
                <em>Overcome</em>
                <span className="home-motto__sub">every obstacle</span>
              </span>
              <span className="home-motto__divider" aria-hidden="true">—</span>
              <span className="home-motto__word">
                <em>Evolve</em>
                <span className="home-motto__sub">without limits</span>
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ── What We Do ── */}
      <section id="services" className="section home-services">
        <div className="container">
          <div className="section-heading">
            <span className="label">What We Do</span>
            <h2>End-to-end <span className="gradient-text">digital solutions</span>.</h2>
            <p>From discovery to deployment and beyond — we handle every layer of the modern web stack.</p>
          </div>

          <div className="home-capabilities">
            {CAPABILITIES.map(({ icon, title, desc }) => (
              <div key={title} className="home-capability">
                <div className="home-capability__icon" aria-hidden="true">{icon}</div>
                <div className="home-capability__text">
                  <h3 className="home-capability__title">{title}</h3>
                  <p className="home-capability__desc">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Contact ── */}
      <section id="contact" className="section home-contact">
        <div className="container home-contact__grid">

          <div className="home-contact__left">
            <span className="label">Get In Touch</span>
            <h2>Let's build something <span className="gradient-text">great</span>.</h2>
            <p className="home-contact__body">
              Tell us about your project. We typically respond within one business day
              with a thoughtful reply — not a template.
            </p>

            <div className="home-contact__info">
              <div className="home-contact__info-item">
                <span className="home-contact__info-label">Email</span>
                <a href="mailto:chris.hartwig@adaptive-web-solutions.com" className="home-contact__info-value">
                  chris.hartwig@adaptive-web-solutions.com
                </a>
              </div>
              <div className="home-contact__info-item">
                <span className="home-contact__info-label">Location</span>
                <span className="home-contact__info-value">Clearwater, FL · Remote-first</span>
              </div>
              <div className="home-contact__info-item">
                <span className="home-contact__info-label">Availability</span>
                <span className="home-contact__info-value home-contact__available">
                  <span className="home-contact__dot" aria-hidden="true" />
                  Accepting new projects
                </span>
              </div>
            </div>
          </div>

          {/* <div className="home-contact__form-wrap">
            <ContactForm />
          </div> */}
        </div>
      </section>
    </>
  )
}

const CAPABILITIES = [
  {
    icon: <CodeIcon />,
    title: 'Web Development',
    desc: 'Full-stack React 19 and Node applications. Built for performance, accessibility, and growth.',
  },
  {
    icon: <PenIcon />,
    title: 'UI/UX Design',
    desc: 'Human-centered design systems. Beautiful interfaces that are intuitive and convert.',
  },
  {
    icon: <DatabaseIcon />,
    title: 'Database',
    desc: 'We design, build, and optimize databases that power your applications. From schema architecture and data modeling to complex query optimization and ongoing development.',
  },
  {
    icon: <TerminalIcon />,
    title: 'Coding',
    desc: 'We turn your ideas into working software — crafting custom code that\'s fast, scalable, and built around your specific business needs.',
  },
  // {
  //   icon: <ZapIcon />,
  //   title: 'Performance Optimization',
  //   desc: 'Core Web Vitals, bundle analysis, server tuning. Every millisecond is competitive advantage.',
  // },
  // {
  //   icon: <CloudIcon />,
  //   title: 'Cloud & DevOps',
  //   desc: 'Scalable infrastructure on AWS, automated CI/CD, containerized deployments. Zero-downtime.',
  // },
  // {
  //   icon: <SearchIcon />,
  //   title: 'SEO & Analytics',
  //   desc: 'Technical SEO, structured data, and GA4 dashboards that show you what actually matters.',
  // },
  {
    icon: <PuzzleIcon />,
    title: 'Custom Integrations',
    desc: 'Connect APIs, CRMs, address checks, and/or payment systems to your stack.',
  },
]

function CodeIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
}
function PenIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
}
function DatabaseIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v5c0 1.657 3.582 3 8 3s8-1.343 8-3V5"/><path d="M4 10v5c0 1.657 3.582 3 8 3s8-1.343 8-3v-5"/></svg>
}
function TerminalIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="18" rx="2"/><line x1="2" y1="7" x2="22" y2="7"/><polyline points="6 12 9 14.5 6 17"/><line x1="11" y1="17" x2="16" y2="17"/></svg>
}
// function ZapIcon() {
//   return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
// }
// function CloudIcon() {
//   return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></svg>
// }
// function SearchIcon() {
//   return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
// }
function PuzzleIcon() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
}
